import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import { SbSharedSearchSuggestions } from '../SbSharedSearchSuggestions/SbSharedSearchSuggestions';
import { SbSharedTitle } from '../SbSharedTitle/SbSharedTitle';
import {
    FILTER_SEARCH,
    FILTER_REFINE_SEARCH,
} from '../SbSharedRefineMenu/sbSharedRefineMenuConstants';

// styles
import styles from './SbRespNullSearchResultsHeader.scss';

const shouldShowSearchHeader = appliedFilters => {
    return appliedFilters.some(
        ({ name }) => name === FILTER_SEARCH || name === FILTER_REFINE_SEARCH
    );
};

export const SbRespNullSearchResultsHeaderComponent = ({ searchTerm, searchBrowse }) => {
    const { appliedFilters = [] } = searchBrowse;
    return shouldShowSearchHeader(appliedFilters) ? (
        <div className={styles.container}>
            <div className={styles.results}>
                <FormattedMessage
                    id="sb.SbRespNullSearchResultsHeader.zeroResults"
                    defaultMessage={`0 results for "{searchTerm}"`}
                    values={{ searchTerm }}
                />
            </div>
            <SbSharedSearchSuggestions
                className={styles.searchSuggestions}
                searchBrowse={searchBrowse}
            />
        </div>
    ) : (
        <SbSharedTitle searchBrowse={searchBrowse} searchTerm={searchTerm} />
    );
};

SbRespNullSearchResultsHeaderComponent.propTypes = {
    searchTerm: PropTypes.string,
    searchBrowse: PropTypes.object.isRequired,
};

export const SbRespNullSearchResultsHeader = createFragmentContainer(
    SbRespNullSearchResultsHeaderComponent,
    {
        searchBrowse: graphql`
            fragment SbRespNullSearchResultsHeader_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedSearchSuggestions_searchBrowse
                ...SbSharedTitle_searchBrowse
                appliedFilters {
                    name
                }
            }
        `,
    }
);
